import { ThemeConfig } from 'antd';
import { COLORS, TEXT_SIZES } from '../utils/constants';

const themeConfig: ThemeConfig = {
  token: {
    // Global tokens
    colorPrimary: COLORS.skyBlue.primary,
    colorBgContainer: COLORS.white.primary,
    borderRadius: 8,
    colorText: COLORS.grey.primary,
    fontSize: TEXT_SIZES.SM,
  },
  components: {
    Button: {
      borderRadius: 4,

      // Create/Primary button
      colorPrimary: COLORS.skyBlue.primary,
      colorPrimaryHover: COLORS.skyBlue.primary,
      primaryColor: COLORS.white.primary,

      // Cancel/Default button
      defaultBg: COLORS.grey.secondaryLight,
      defaultColor: COLORS.grey.primary,
      defaultBorderColor: COLORS.grey.secondaryLight,
      defaultHoverBg: COLORS.grey.secondaryLight,
      defaultHoverBorderColor: COLORS.grey.secondaryLight,
      defaultHoverColor: COLORS.grey.primary,
      defaultActiveBg: COLORS.grey.secondaryLight,
      defaultActiveBorderColor: COLORS.grey.secondaryLight,
      defaultActiveColor: COLORS.grey.primary,

      // Delete/Danger button
      colorError: COLORS.red.primary,
      colorErrorHover: COLORS.red.primary,
      colorErrorActive: COLORS.red.primary,
      colorTextLightSolid: COLORS.white.primary,
    },
    Input: {
      colorBorder: COLORS.grey.secondaryLight,
      borderRadiusLG: 8,
      borderRadius: 8,
    },
    InputNumber: {
      colorBorder: COLORS.grey.secondaryLight,
      borderRadiusLG: 8,
      borderRadius: 8,
      controlHeightLG: 43,
      controlHeight: 43,
    },
    Select: {
      colorBorder: COLORS.grey.secondaryLight,
    },
    Modal: {
      headerBg: COLORS.blue.primary,
      titleColor: COLORS.white.primary,
    },

    Table: {
      headerBg: COLORS.skyBlue.primary,
      headerColor: COLORS.white.primary,
      // rowHoverBg: COLORS.grey.secondary, //yet to get the correct color
      borderRadius: 8,
    },
    Card: {
      colorBorder: COLORS.grey.secondary,
    },
    Menu: {
      itemSelectedBg: COLORS.skyBlue.secondary,
      itemSelectedColor: COLORS.grey.primary,
      itemHoverBg: COLORS.skyBlue.secondary,
      itemBorderRadius: 8,
    },
    Breadcrumb: {
      separatorColor: COLORS.grey.secondaryLight,
      lastItemColor: COLORS.grey.primary,
    },
  },
};

export default themeConfig;
